import React from 'react'
import cookies from '../assets/cookies.png'
import dataprotection from '../assets/dataprotection.png'
import privacypolicy from '../assets/privacypolicy.png'
import sensitive from '../assets/sensitive.png'
import terms from '../assets/terms.png'

const BottomFooter = () => {
    return (
        <footer className="footer">
            <h4>Designed and Developed by the hardwork of the following individuals</h4>
            <ul>
                <li>
                    <a href="https://www.linkedin.com/in/anubhavsingh1998/" target="_blank" rel="noreferrer noopener">Anubhav Singh</a>
                </li>
                <li>
                    <a href="https://www.linkedin.com/in/tyrone-saldanha-69420/" target="_blank" rel="noreferrer noopener">Tyrone Saldanha</a>
                </li>
                <li>
                    <a href="https://www.linkedin.com/in/vedangdubale/" target="_blank" rel="noreferrer noopener">Vedang Dubale</a>
                </li>
                <li>
                    <a href="https://www.linkedin.com/in/aric-pereira-b42245193/" target="_blank" rel="noreferrer noopener">Aric Pereira</a>
                </li>
            </ul>
            <p>&copy; 2020. All Rights Reserved.</p>
            <div className="privacyPolicySection">
                <a href="/terms" title="Terms & Condition">
                    <img src={terms} />
                </a>
                <a href="/privacy" title="Privacy Policy">
                    <img src={privacypolicy} />
                </a>

            </div>
        </footer>
    )
}

export default BottomFooter;